import { useTexts } from "Components/TextContext";
import { isDefined } from "Utils/functions";
import React from "react";
import { TffMessage } from "./styled";

interface Props {
  fee?: number;
}

export const TFFInfoBoxMonthly = ({
  fee,
}: Props): React.ReactElement | null => {
  const { getText } = useTexts();

  if (!isDefined(fee)) {
    return null;
  }

  const tffMessage = getText("checkprice.common.tffmonthlyfee", {
    variables: {
      tffMonthlyFee: fee,
    },
  });
  return <TffMessage>{tffMessage}</TffMessage>;
};
